import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useCompanyBillingStore = defineStore({
  id: 'companyBillingStore',
  actions: {
    async getQuickBooksCustomers(company_hash) {
      const {data} = await axios.get('quick-books-customers', {params: {company_hash}})

      return data
    },

    // Invoices
    async getInvoiceInfo(id, params) {
      const {data} = await axios.get(`company-invoices/${id}`, {params})

      return data
    },

    async getInvoices(filters) {
      const {data} = await axios.get('company-invoices', {params: filters})

      return data
    },

    async getInvoicesSummary(params) {
      const {data} = await axios.get('company-invoices/summary', {params})

      return data
    },

    async getInvoiceRequisites(payment_type) {
      const {data} = await axios.get('company-invoices/requisites', {params: {payment_type}})

      return {requisites: data.requisites, tag: data.tag ?? null}
    },

    async createInvoice(payload, params) {
      const {data} = await axios.post('company-invoices', payload, {params})

      return data
    },

    async sendInvoiceEmail(hash, email) {
      const {data} = await axios.post(`company-invoices/${hash}/send`, {email})

      return data
    },

    async getInvoiceRequisitesPublic(payment_type) {
      const {data} = await axios.get('public/company-invoices/requisites', {params: {payment_type}})

      return {requisites: data.requisites, tag: data.tag ?? null}
    },

    async createProformaInvoicePublic(payload, params) {
      const {data} = await axios.post('public/company-invoices', payload, {params})

      return data
    },

    // Payments
    async getPaymentsSummary(params) {
      const {data} = await axios.get('company-payments/summary', {params})

      return data
    },

    async createPayment(payload, params) {
      const {data} = await axios.post(`company-payments`, payload, {params})

      return data
    },

    async getPaymentInfo(id, params) {
      const {data} = await axios.get(`company-payments/${id}`, {params})

      return data
    },

    async getPayments(filters = {}) {
      const {data} = await axios.get('company-payments', {params: filters})

      return data
    },
  },
})
